export const SELECT_DICTIONARY = {
	others: 'Otros',
};
